import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthContextProvider } from './store/auth-context';
import ConfigureUIStore from './hooks-store/ui-store';
import ConfigureAccessStore from './hooks-store/access-store';
import ConfigureCurrentStore from './hooks-store/current-store';

ConfigureUIStore();
ConfigureAccessStore();
ConfigureCurrentStore();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthContextProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AuthContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
